/*
 * SPDX-FileCopyrightText: 2020 CERN.
 * SPDX-License-Identifier: MIT
 */

import React from "react";

export const SearchConfigurationContext = React.createContext({});
